/* Mounts the store design into #pp-app and hides the server-rendered fallback. */
(function () {
  'use strict';
  function boot() {
    var el = document.getElementById('pp-app');
    if (!el || !window.PPDC || !window.PPShop) return;
    try {
      PPDC.mount('Paper Predict Store', el, (window.PP && PP.props) || {});
      document.documentElement.classList.add('pp-ready');
    } catch (e) {
      // keep the server-rendered page if the app fails for any reason
      console.error('[pp] mount failed', e);
      document.documentElement.classList.add('pp-failed');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
